/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileTypePictureIcon16Light } from './FileTypePictureIcon16Light';
import { FileTypePictureIcon16Regular } from './FileTypePictureIcon16Regular';
import { FileTypePictureIcon16Solid } from './FileTypePictureIcon16Solid';
import { FileTypePictureIcon20Light } from './FileTypePictureIcon20Light';
import { FileTypePictureIcon20Regular } from './FileTypePictureIcon20Regular';
import { FileTypePictureIcon20Solid } from './FileTypePictureIcon20Solid';
import { FileTypePictureIcon24Regular } from './FileTypePictureIcon24Regular';
import { FileTypePictureIcon24Solid } from './FileTypePictureIcon24Solid';
import { FileTypePictureIcon32Regular } from './FileTypePictureIcon32Regular';
import { FileTypePictureIcon64Regular } from './FileTypePictureIcon64Regular';
var sizes = {
    16: {
        light: FileTypePictureIcon16Light,
        regular: FileTypePictureIcon16Regular,
        solid: FileTypePictureIcon16Solid,
    },
    20: {
        light: FileTypePictureIcon20Light,
        regular: FileTypePictureIcon20Regular,
        solid: FileTypePictureIcon20Solid,
    },
    24: {
        regular: FileTypePictureIcon24Regular,
        solid: FileTypePictureIcon24Solid,
    },
    32: {
        regular: FileTypePictureIcon32Regular,
    },
    64: {
        regular: FileTypePictureIcon64Regular,
    },
};
export var FileTypePictureIcon = forwardRef('FileTypePictureIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
